import * as runtime from '@podlove/player-actions/runtime'
import * as init from '@podlove/player-actions/init'
import * as error from '@podlove/player-actions/error'

export default {
  ...runtime,
  ...init,
  ...error
}
